import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AppMainComponent } from '../../../app.main.component';
import { AppMainService } from '../../../app-main.service';
import { ObjectNames } from '../../../shared/constants';
import { ConfigurationService } from '../../configurationService';
import { MenuItems, ObjectNames as ChannelObjectNames } from '../constants/constants';
import { CrmAccountService } from './account.service';
import { AccountModuleId } from '../../../modules/shared/constants/modules.constant';

@Component({
  selector: 'app-crm-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class CrmAccountComponent implements OnInit {
  moduleId: number = AccountModuleId;

  caseChannelConfig;
  allCaseChannels = [];

  allcaseTypeTemplateJSON;
  caseTemplatesConfig;
  allCaseTemplates = [];

  configMenuCaseItems: any[] = [];
  index = 0;
  caseChannelId;
  templateTypeId;
  pipelineTypeId = null;

  sectionTypeId
  addNewElement;
  addNewField;

  //fields
  accountFieldConfig = null
  // allAccountfieldJSON = [];

  accountTranslate = {
    Channel: "",
    FieldData: ""
  }

  constructor(
    private service: ConfigurationService,
    private appMainService: AppMainService,
    public app: AppMainComponent,
    private crmAccountService: CrmAccountService,
    private translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    this.getTranslatedValue();
    // this.getConfigurationTypes();
    this.configMenuCaseItems = [
      {
        label: this.accountTranslate.Channel,
        icon: 'pi pi-plus',
        command: () => {
          this.addNewCaseChannel();
        }
      },
      {
        label: this.accountTranslate.FieldData,
        icon: 'pi pi-plus',
        command: () => {
          this.addNewCaseFieldData();
        }
      },
    ];
  }

  getTranslatedValue() {
    this.translocoService.selectTranslate('Configuration.CRM.Channel').subscribe((data) => {
      this.accountTranslate.Channel = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Field_Data').subscribe((data) => {
      this.accountTranslate.FieldData = data;
    });
  }

  getConfigurationTypes() {
    this.appMainService.isShowSpinner('loadTypes')
    this.crmAccountService.getAllTypes().subscribe(
      types => {
        this.appMainService.isHideSpinner('loadTypes')
        this.caseChannelId = types.find(type => type.name == ChannelObjectNames.caseConstants.Channel_Object).id;
        this.templateTypeId = types.find(type => type.name == ChannelObjectNames.caseConstants.Channel_Template).id;
        this.pipelineTypeId = types.find(type => type.name == ChannelObjectNames.caseConstants.Pipeline_Object).id;
        this.loadConfigurations();
      },
      err => {
        this.appMainService.isHideSpinner('loadTypes')
      })
  }

  getIndex(event) {
    this.index = event.index;
    this.addNewField ='';
    // if (this.index === 1) {
    //   this.loadConfigurations();
    // }
  }

  reLoadConfigurations(event) {
    this.loadConfigurations();
  }

  loadConfigurations() {
    this.allCaseTemplates = [];
    this.appMainService.isShowSpinner('loadConfiguration')
    this.service.getCaseConfigurations('account').subscribe(
      configs => {
        this.appMainService.isHideSpinner('loadConfiguration')
        //Case channel
        this.caseChannelConfig = configs.find(s => s.name == ObjectNames.ACCOUNT_CHANNEL && s.typeId == this.caseChannelId);
        const allCaseChannelsJSON = (this.caseChannelConfig && this.caseChannelConfig.configurationDetails && this.caseChannelConfig.configurationDetails[0].configJSONValue != "" ? JSON.parse(this.caseChannelConfig.configurationDetails[0].configJSONValue) : []);
        this.allCaseChannels = allCaseChannelsJSON.filter(obj => obj.id > 0);
        ////console.log('this.allCaseChannels', this.allCaseChannels)

        //Case Template
        this.caseTemplatesConfig = configs.find(s => s.name == ObjectNames.ACCOUNT_TEMPLATE && s.typeId == this.templateTypeId);
        this.allcaseTypeTemplateJSON = (this.caseTemplatesConfig && this.caseTemplatesConfig.configurationDetails && this.caseTemplatesConfig.configurationDetails[0].configJSONValue != "" ? JSON.parse(this.caseTemplatesConfig.configurationDetails[0].configJSONValue) : []);
        this.allCaseTemplates = this.allcaseTypeTemplateJSON.filter(obj => obj.id > 0);
        // console.log('this.allcaseTypeTemplateJSON', this.allcaseTypeTemplateJSON)
        // console.log('this.allCaseTemplates', this.allCaseTemplates)

        //fields data
        this.accountFieldConfig = configs.filter(s => s.name == ObjectNames.ACCOUNT_EMAIL_TYPES || s.name == ObjectNames.ACCOUNT_PHONE_TYPES || s.name == ObjectNames.ACCOUNT_SOCIAL_TYPES);
        //this.allAccountfieldJSON = this.accountFieldConfig != null ? JSON.parse(this.accountFieldConfig.configurationDetails && this.accountFieldConfig.configurationDetails[0].configJSONValue) : [];
        // this.emailTypes = this.allAccountfieldJSON.length ? this.allAccountfieldJSON.filter(s => s.name == "Account Email Types") : [];
        // this.phoneTypes = this.allAccountfieldJSON.length ? this.allAccountfieldJSON.filter(s => s.name == "Account Phone Types") : [];
        // this.socialProfileTypes = this.allAccountfieldJSON.length ? this.allAccountfieldJSON.filter(s => s.name == "Account Social Types") : [];

      },
      err => {
        this.appMainService.isHideSpinner('loadConfiguration')
      }
    );
  }

  addNewCaseChannel() {
    this.addNewElement = { name: MenuItems.Add_Event_Channel };
    this.index = 0;
  }

  addNewCaseFieldData() {
    this.index = 2;
    this.addNewField = { name: MenuItems.Add_Event_Field };
  }

  cancelChannelAddUpdateModal(): void {
    this.addNewElement = null;
  }
}